/**
 * @generated SignedSource<<fc905477be721c30b5b07cf4a987d83f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addVariantOptionsListQuery$variables = {
  salesChannelID: string;
  sku: string;
};
export type addVariantOptionsListQuery$data = {
  readonly productVariantImageMatches: ReadonlyArray<{
    readonly imageUrl: string | null;
    readonly selections: ReadonlyArray<{
      readonly label: string;
      readonly optionID: string;
      readonly value: {
        readonly id: string;
        readonly label: string;
      };
    } | null> | null;
  }>;
};
export type addVariantOptionsListQuery = {
  response: addVariantOptionsListQuery$data;
  variables: addVariantOptionsListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "salesChannelID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sku"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "salesChannelID",
        "variableName": "salesChannelID"
      },
      {
        "kind": "Variable",
        "name": "sku",
        "variableName": "sku"
      }
    ],
    "concreteType": "MerchantProductVariantImageMatch",
    "kind": "LinkedField",
    "name": "productVariantImageMatches",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MerchantProductOptionSelection",
        "kind": "LinkedField",
        "name": "selections",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "optionID",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MerchantProductOptionValue",
            "kind": "LinkedField",
            "name": "value",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "addVariantOptionsListQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "addVariantOptionsListQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "7725921d626742c5c20f14822619e630",
    "id": null,
    "metadata": {},
    "name": "addVariantOptionsListQuery",
    "operationKind": "query",
    "text": "query addVariantOptionsListQuery(\n  $sku: String!\n  $salesChannelID: ID!\n) {\n  productVariantImageMatches(sku: $sku, salesChannelID: $salesChannelID) {\n    imageUrl\n    selections {\n      optionID\n      label\n      value {\n        id\n        label\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f800475e82eee0dff58ef4a108ef8e6b";

export default node;
